import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTour } from './OnboardingTour';

/**
 * Renders nothing visible. When mounted on a page with ?onboarded=true,
 * starts the welcome onboarding tour after a short delay.
 */
export function OnboardingTourTrigger() {
  const [searchParams] = useSearchParams();
  const { startTour } = useTour();
  const hasTriggered = useRef(false);

  useEffect(() => {
    const shouldStart = searchParams.get('onboarded') === 'true';
    if (shouldStart && !hasTriggered.current) {
      hasTriggered.current = true;
      // Delay to ensure all nav elements are rendered
      const timer = setTimeout(() => {
        startTour('welcome');
      }, 800);
      return () => clearTimeout(timer);
    }
  }, [searchParams, startTour]);

  return null;
}
